<script lang="ts">
	/**
	 * Discovered header. New layout: Add by IP and Retry live in the Home tabs
	 * kebab (`$listHeader`); there is no inline toolbar. Old layout keeps the
	 * breadcrumbs Toolbar verbatim.
	 */
	import { onDestroy } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Toolbar, Button, IconButton, Breadcrumbs, Text } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import { network } from 'src/stores/session/native-bridge';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { createListHeaderHandle } from 'src/stores/list_header';
	import type { MenuItemListExtendedProps } from 'src/components/Dashboards/dash-types';

	export let inclusionData;
	export let mode = false;
	export let scanNetwork;

	const headerHandle = createListHeaderHandle();

	const discoveredDevicesBreadcrumbs = [
		{
			label: !inclusionData
				? $format('discovered_devices', { default: 'discovered devices' })
				: capFirstChar(
						$format('via_wifi_scan', {
							default: 'Scan Network',
						}),
					),
		},
	];

	$: buttonText = mode
		? $format('button_discovered_list', { default: 'discovered list' })
		: $format('button_add_by_ip', { default: 'add by ip' });

	const handleToggle = () => {
		if (inclusionData) inclusionData.selected = undefined;
		mode = !mode;
	};

	const handleRefresh = () => {
		scanNetwork();
	};

	// Home Discovered tab only. The inclusion wizard reuses this list and must
	// keep its own Scan Network header — do not publish onto Home tabs.
	$: if ($showNewLayout && !inclusionData) {
		const items: MenuItemListExtendedProps[] = [
			{
				title: mode
					? $format('button_discovered_list', { default: 'Discovered list' })
					: $format('button_add_by_ip', { default: 'Add by IP' }),
				icon: mode ? 'fas fa-list' : 'fas fa-plus',
				onClick: handleToggle,
			},
		];
		if (!mode) {
			items.push({
				title: $format('button_retry', { default: 'Retry' }),
				icon: 'fas fa-arrows-rotate',
				disabled: $network !== 'wifi',
				onClick: handleRefresh,
			});
		}
		headerHandle.set({ menuItems: [{ items }] });
	}

	onDestroy(() => {
		headerHandle.clear();
	});
</script>

{#if inclusionData}
	<div class="d-flex align-items-center justify-content-between mb-m">
		<Text element="h2">
			{capFirstChar(
				$format('via_wifi_scan', {
					default: 'Scan Network',
				}),
			)}
		</Text>
		<div class="d-flex align-items-center">
			{#if !mode}
				<IconButton
					aria-label={$format('button_refresh_scan', {
						default: 'Button refresh scan',
					})}
					class="mr-s"
					icon="fas fa-arrows-rotate"
					on:click={handleRefresh}
					disabled={$network !== 'wifi'}
				/>
			{/if}
			<Button class="align-self-center text-capitalize" size="m" on:click={handleToggle}>
				{buttonText}
			</Button>
		</div>
	</div>
{:else if !$showNewLayout}
	<Toolbar class="mb-m" hideSlotBottom>
		<svelte:fragment slot="breadcrumbs">
			<Breadcrumbs
				aria-label={$format('label_discovered_devices', { default: 'Discovered devices' })}
				class="text-capitalize"
				links={discoveredDevicesBreadcrumbs}
			/>
		</svelte:fragment>

		<svelte:fragment slot="rightSide">
			{#if !mode}
				<IconButton
					aria-label={$format('button_refresh_scan', {
						default: 'Button refresh scan',
					})}
					icon="fas fa-arrows-rotate"
					on:click={handleRefresh}
					disabled={$network !== 'wifi'}
				/>
			{/if}
			<Button class="align-self-center text-capitalize" size="m" on:click={handleToggle}>
				{buttonText}
			</Button>
		</svelte:fragment>
	</Toolbar>
{/if}
